import { HttpErrorResponse } from '@angular/common/http';
import { ITagDTO, ITagUsageDTO } from '@modeso/types__aumico-lib-companies-be';
import { createAction, props } from '@ngrx/store';

// REV-22155 — tags of the organization (persons + companies). Per action: start, success, failure.

// **Get Tags */
export const getTags = createAction('[Aumico-Tags] getTags');
export const onGettingTagsSuccessfully = createAction(
    '[Aumico-Tags] onGettingTagsSuccessfully',
    props<{ payload: ITagDTO[] }>(),
);
export const onGettingTagsFailed = createAction('[Aumico-Tags] onGettingTagsFailed', props<{ payload: HttpErrorResponse }>());

// **Create Tag */
export const createTag = createAction('[Aumico-Tags] createTag', props<{ name: string }>());
export const onCreateTagSuccessfully = createAction('[Aumico-Tags] onCreateTagSuccessfully', props<{ payload: ITagDTO }>());
export const onCreateTagFailed = createAction('[Aumico-Tags] onCreateTagFailed', props<{ payload: HttpErrorResponse }>());

// **Tag usage — asked when the "x" on a pill is clicked */
export const getTagUsage = createAction('[Aumico-Tags] getTagUsage', props<{ id: string }>());
export const onGettingTagUsageSuccessfully = createAction(
    '[Aumico-Tags] onGettingTagUsageSuccessfully',
    props<{ id: string; payload: ITagUsageDTO }>(),
);
export const onGettingTagUsageFailed = createAction(
    '[Aumico-Tags] onGettingTagUsageFailed',
    props<{ payload: HttpErrorResponse }>(),
);
/** Warning closed without deleting. */
export const clearTagUsage = createAction('[Aumico-Tags] clearTagUsage');

// **Delete Tag */
export const deleteTag = createAction('[Aumico-Tags] deleteTag', props<{ id: string }>());
export const onDeleteTagSuccessfully = createAction('[Aumico-Tags] onDeleteTagSuccessfully', props<{ id: string }>());
export const onDeleteTagFailed = createAction('[Aumico-Tags] onDeleteTagFailed', props<{ payload: HttpErrorResponse }>());

export const resetTagsErrors = createAction('[Aumico-Tags] resetTagsErrors');
/** Logout: no tags of the previous user's organization stay in the browser. */
export const resetTags = createAction('[Aumico-Tags] resetTags');
